<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="收款账户"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">预付余额：</td>
                  <td class="data">
                    {{ this.form1.forceBalance}}
                  </td>
                  <td class="first">实时余额：</td>
                  <td class="data">
                    {{ this.form1.reBalance}}
                  </td>
                  <td class="first">当前可用余额：</td>
                  <td class="data">
                    {{ this.form1.curBalance}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
<!--        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="付款账户"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">预付余额：</td>
                  <td class="data">
                    {{ this.form2.forceBalance}}
                  </td>
                  <td class="first">实时余额：</td>
                  <td class="data">
                    {{ this.form2.reBalance}}
                  </td>
                  <td class="first">当前可用余额：</td>
                  <td class="data">
                    {{ this.form2.curBalance}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>-->
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="分账商户账户"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">预付余额：</td>
                  <td class="data">
                    {{ this.form3.forceBalance}}
                  </td>
                  <td class="first">实时余额：</td>
                  <td class="data">
                    {{ this.form3.reBalance}}
                  </td>
                  <td class="first">当前可用余额：</td>
                  <td class="data">
                    {{ this.form3.curBalance}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="分账接收方账户"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">预付余额：</td>
                  <td class="data">
                    {{ this.form4.forceBalance}}
                  </td>
                  <td class="first">实时余额：</td>
                  <td class="data">
                    {{ this.form4.reBalance}}
                  </td>
                  <td class="first">当前可用余额：</td>
                  <td class="data">
                    {{ this.form4.curBalance}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
      </table>
    </div>
    <div style="height: 25px">
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">
          {{$t('取消')}}
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {balance} from '@/api/merchant/extraApplyLakala'
import CustomDictTag from "@/components/DictCustomTag/index.vue";

export default {
  name: 'balance',
  components: {CustomDictTag},
  props: {
  },
  data() {
    return {
      title:undefined,
      loading: false,
      visible: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      filteredInfo: {},
      sortedInfo : {},
      total:0,
      queryParam: {
        id: undefined,
        payType: "01",
        pageNum: 1,
        pageSize: 10
      },
      form1: {
        forceBalance: 0,
        curBalance: 0,
        reBalance: 0,
        freezeBalance: 0,
      },
      form2: {
        forceBalance: 0,
        curBalance: 0,
        reBalance: 0,
        freezeBalance: 0,
      },
      form3: {
        forceBalance: 0,
        curBalance: 0,
        reBalance: 0,
        freezeBalance: 0,
      },
      form4: {
        forceBalance: 0,
        curBalance: 0,
        reBalance: 0,
        freezeBalance: 0,
      },
      form5: {},

      list: [],
    }
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    handleCancel() {
      this.visible=false
      this.list=[]
      this.reset()
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    reset() {
      this.form  = {
        orderId: undefined,
        addressId: undefined,
        isAdmin: true
      }
      this.selectedRowKeys=[]
      this.selectedRows = []
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    /** 修改按钮操作 */
    handleDetail(id) {
      balance({"id":id, payType: "01"}).then(res => {
        this.form1 = res.data
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });
      /*balance({"id":id, payType: "02"}).then(res => {
        this.form2 = res.data
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });*/
      balance({"id":id, payType: "03"}).then(res => {
        this.form3 = res.data
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });
      balance({"id":id, payType: "04"}).then(res => {
        this.form4 = res.data
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });
    },

  }
}
</script>
<style scoped>
.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 100px;
    }

    .data {
      width: 300px;
    }
  }
}

</style>
